// Config da página intermediária — espelha a validação do backend
// (src/services/redirects/interstitial.py) e o render do redirect-spectrum
// (static/interstitial.js). Mudou lá? Muda aqui.

export const DEFAULT_BUTTON = "Toque AQUI para me chamar";
export const MAX_AVATAR_BYTES = 2 * 1024 * 1024;
export const LIMITS = { name: 40, button_text: 40, response_time: 24 };
export const COUNTDOWN_MIN = 3;
export const COUNTDOWN_MAX = 30;

export const DEFAULT_CONFIG = {
    template: "rosa",
    name: "",
    verified: false,
    button_text: DEFAULT_BUTTON,
    response_time: "3 minutos",
    auto_redirect: false,
    show_telegram_icon: true,
    custom_color: "#8b5cf6",
    countdown_seconds: 5,
};

export const PROFILE_TEMPLATES = [
    { id: "rosa", label: "Rosa", bg: "#f472b6" },
    { id: "azul", label: "Azul", bg: "linear-gradient(135deg, #0c1929, #2563eb)" },
    { id: "escuro", label: "Escuro", bg: "linear-gradient(180deg, #0a0a0a, #1a1a1a)" },
    { id: "roxo", label: "Roxo", bg: "linear-gradient(135deg, #581c87, #7c3aed)" },
    { id: "verde", label: "Verde", bg: "linear-gradient(135deg, #064e3b, #059669)" },
    { id: "custom", label: "Custom", bg: null },
];

export const INTERACTIVE_TEMPLATES = [
    { id: "raspadinha", label: "Raspadinha", emoji: "🤫", bg: "radial-gradient(120% 70% at 50% 30%, rgba(139, 92, 246, 0.14), transparent 60%), #0a0a0a", cta: "Acessar Conteúdo" },
    { id: "verificacao", label: "Verificação", emoji: "🛡️", bg: "linear-gradient(135deg, #1e293b, #0f172a)", cta: "Continuar" },
    { id: "countdown", label: "Countdown", emoji: "⏳", bg: "linear-gradient(135deg, #0c1929, #1e3a5f)", cta: "Acessar agora" },
    { id: "mais18", label: "+18", emoji: "⚠️", bg: "#141414", cta: "Tenho 18 anos ou mais" },
    { id: "presente", label: "Presente", emoji: "🎁", bg: "linear-gradient(135deg, #0f0524, #1a0a3e)", cta: "Acessar Conteúdo" },
];

const ALL_IDS = [...PROFILE_TEMPLATES, ...INTERACTIVE_TEMPLATES].map((t) => t.id);

export const isProfileTemplate = (id) => PROFILE_TEMPLATES.some((t) => t.id === id);

export const templateGroup = (id) => (isProfileTemplate(id) ? "profile" : "interactive");

export function templateMeta(id) {
    return PROFILE_TEMPLATES.find((t) => t.id === id) || INTERACTIVE_TEMPLATES.find((t) => t.id === id) || PROFILE_TEMPLATES[0];
}

/** Campos do formulário que fazem sentido para o template escolhido. */
export function fieldsFor(template) {
    if (isProfileTemplate(template)) {
        const f = ["avatar", "name", "verified", "button_text", "show_telegram_icon", "response_time", "auto_redirect"];
        return template === "custom" ? [...f, "custom_color"] : f;
    }
    // Interativos: texto do botão fixo por template (não personalizável).
    return template === "countdown" ? ["countdown_seconds"] : [];
}

/** Texto do CTA como o redirect-spectrum renderiza. */
export function ctaText(config) {
    if (isProfileTemplate(config.template)) return config.button_text || DEFAULT_BUTTON;
    return INTERACTIVE_TEMPLATES.find((t) => t.id === config.template)?.cta || DEFAULT_BUTTON;
}

export function normalizeConfig(raw) {
    const cfg = { ...DEFAULT_CONFIG };
    if (!raw || typeof raw !== "object") return cfg;
    for (const k of Object.keys(DEFAULT_CONFIG)) {
        if (raw[k] !== undefined && raw[k] !== null) cfg[k] = raw[k];
    }
    if (!ALL_IDS.includes(cfg.template)) cfg.template = DEFAULT_CONFIG.template;
    return cfg;
}

export function buildConfigPayload(enabled, config) {
    const c = normalizeConfig(config);
    return {
        enabled: enabled === true,
        config: {
            template: c.template,
            name: String(c.name || "").trim(),
            verified: c.verified === true,
            button_text: String(c.button_text || "").trim() || DEFAULT_BUTTON,
            response_time: String(c.response_time || "").trim() || DEFAULT_CONFIG.response_time,
            auto_redirect: c.auto_redirect === true,
            show_telegram_icon: c.show_telegram_icon !== false,
            custom_color: c.custom_color,
            countdown_seconds: parseInt(c.countdown_seconds, 10) || DEFAULT_CONFIG.countdown_seconds,
        },
    };
}

export function validateAvatarFile(file) {
    if (!file) return "Selecione uma imagem.";
    if (!["image/jpeg", "image/png", "image/webp"].includes(file.type)) {
        return "Formato não suportado. Use JPG, PNG ou WEBP.";
    }
    if (file.size > MAX_AVATAR_BYTES) return "Imagem muito grande (máx. 2 MB).";
    return null;
}

export function validateSafeUrl(url, ownBaseUrl = "") {
    const v = (url || "").trim();
    if (!v) return "Informe a URL segura.";
    let u;
    try {
        u = new URL(v);
    } catch {
        return "Use uma URL completa começando com https://";
    }
    if (u.protocol !== "https:") return "Use uma URL completa começando com https://";
    if (ownBaseUrl) {
        try {
            const own = new URL(ownBaseUrl).hostname.toLowerCase();
            const host = u.hostname.toLowerCase();
            if (own && (host === own || host.endsWith(`.${own}`))) {
                return "A URL segura não pode apontar para o próprio redirecionador.";
            }
        } catch { /* base inválida: ignora */ }
    }
    return null;
}
